import { inject } from 'tsyringe'
import { containerScoped } from '~/decorators/dependency-container'
import RequestBuilder from '~/builders/http/RequestBuilder'
import { PriceTrendsResult } from '~/models/statistics/types'
import VueRouter from 'vue-router'

@containerScoped()
export default class PriceTrendsService {
  constructor(
    @inject(RequestBuilder) private requestBuilder: RequestBuilder,
    @inject(VueRouter) private router: VueRouter
  ) {}

  public getPriceTrends(params: object): Promise<PriceTrendsResult> {
    return this.requestBuilder
      .request('get', '/api/real-estate/price-trends/')
      .params(params)
      .send()
  }
}
